import React, { useEffect, useState } from 'react';

const REGION_HINTS = {
  es: 'Advertencia regional: alto volumen de estafas de suplantación en LATAM. Mantente atento a enlaces y perfiles falsos.',
  de: 'Regionale Warnung: Hohe Anzahl an Betrugsfällen in DACH. Vorsicht bei verdächtigen Links und gefälschten Profilen.',
  fr: 'Alerte régionale: forte activité d’arnaques en Europe. Méfiez-vous des liens et profils suspects.',
  ja: '地域アラート：詐欺の発生が増加しています。疑わしいリンクや偽のプロフィールに注意してください。',
};

export default function GeoAdvisoryBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (localStorage.getItem('stopscam_geo_banner_dismissed') === '1') {
      setDismissed(true);
      return;
    }
    const lang = (navigator.language || 'en').toLowerCase();
    const code = lang.split('-')[0];
    const hint = REGION_HINTS[code];
    if (hint) setMessage(hint);
  }, []);

  if (dismissed || !message) return null;

  return (
    <div className="no-print" style={{ background: '#FEF3C7', border: '1px solid #FCD34D', color: '#92400E', padding: '10px 12px', borderRadius: 8, marginBottom: 12 }}>
      <div className="flex items-center justify-between">
        <div>🌍 {message}</div>
        <button onClick={() => { localStorage.setItem('stopscam_geo_banner_dismissed', '1'); setDismissed(true); }} className="px-2 py-1 bg-yellow-100 rounded border">Dismiss</button>
      </div>
    </div>
  );
}